import React from 'react';

import { DataRow, DataRowProps } from './DataRow';

type TaskSnippetProps = DataRowProps;

const TaskSnippet = (props: TaskSnippetProps) => {
  return (
    <DataRow
      {...props}
      data={{
        ...props.data,
        actualStartTime: convertToLocalDateTimeString(props.data.actualStartTime as string),
        actualEndTime: convertToLocalDateTimeString(props.data.actualEndTime as string),
        startTime: convertToLocalDateTimeString(props.data.startTime as string),
        endTime: convertToLocalDateTimeString(props.data.endTime as string),
      }}
      configuration={props.configuration.filter(
        (c) => c.name !== 'state' && c.name !== 'completionPercent' && c.name !== 'taskId',
      )}
      disabled={Object.keys(props.data)}
    />
  );
};

export default TaskSnippet;

const convertToLocalDateTimeString = (unformattedDateTime: string) => {
  if (
    unformattedDateTime === null ||
    unformattedDateTime === undefined ||
    unformattedDateTime === ''
  )
    return;

  const dateTime = new Date(unformattedDateTime);
  return `${dateTime.toLocaleDateString('en-US')} ${dateTime.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
  })}`;
};
